<template>
  <div class="awards">
    <div class="grid">
      <div
        v-for="(item, index) in computedObj"
        :key="index"
        class="grid-item"
      >
        <Award :item="item" />
      </div>
    </div>
    <template v-if="hasLimit">
      <div class="show-more">
        <HighlightButton
          button-type="rounded"
          button-style="outline"
          button-size="small"
          title="Show More"
          @click.native="showMore()"
        />
      </div>
    </template>
  </div>
</template>

<script>
import Award from './Award'
// import HighlightButton from '~/components/sales-bar/highlight-button.vue'

// limit != null && content.length > limit
export default {
  name: 'awards',
  components: {
    Award
  },
  props: {
    content: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      limit: 3
    }
  },
  computed: {
    hasLimit() {
      return this.limit != null && this.content.length > this.limit
    },
    computedObj() {
      return this.limit ? this.content.slice(0, this.limit) : this.content
    }
  },
  methods: {
    showMore() {
      return this.limit = null
    }
  }

}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";
//core grid stucture

.grid{
  --col-size:1;

  @include media-breakpoint-up(lg) { --col-size:3; }
}

.grid {
  grid-template-columns: repeat(var(--col-size), 1fr);
  display: grid;
  grid-gap: 1.5em;
  gap:1.5em;
  row-gap: 2em;

  .grid-item {
    grid-column: span 1;
    display: flex;
    flex-direction: column;
  }
}

//show more position
.show-more {
  margin-top: 1.5em;
  display: flex;
  justify-content: center;
}

</style>>
